export default __webpack_public_path__ + "static/media/TH.56f2474c.svg";